import { ParticipantAgent, UserType } from "../types/context";

export const canUserDoSmallExam = (user: UserType | null) =>
  !!user?.rpu_number && user?.is_certificate_of_passing_the_exam_approved;

export const hasNotAcceptedAgreements = (user: UserType | null): boolean => {
  if (!user) return true;

  return (
    !user.is_agreement_accepted ||
    user.participant_agents?.some(
      (participantAgent) =>
        participantAgent.agent.preferred_agreement_template != null &&
        participantAgent.latest_accepted_agreement == null,
    )
  );
};

export const getAgentParticipantWithoutAcceptedAgreement = (user: UserType | null) => {
  return user?.participant_agents?.find(
    (participantAgent) =>
      participantAgent.agent.preferred_agreement_template !== null &&
      !participantAgent.latest_accepted_agreement,
  );
};

export const getAgentParticipantsArrayWithoutAcceptedAgreement = (
  user: UserType | null,
): ParticipantAgent[] => {
  if (!user) return [];

  return (
    user.participant_agents?.filter(
      (participantAgent) =>
        participantAgent.agent.preferred_agreement_template !== null &&
        !participantAgent.latest_accepted_agreement,
    ) || []
  );
};
